<template>
  <div v-if="isShowReferAFriendReferralCredit" class="opc-cart__referral_credit" >
    <div class="opc-cart__referral_credit-info">
      <h2 class="opc-cart__referral_credit-info-title">
        {{ $t('billing.referral.referral_credit') }}
      </h2>
    </div>
    <div class="opc-cart__referral_credit-price">{{ getReferralCredit }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getReferralCreditUsed',
    ]),
    getReferralCredit() {
      return this.$money(-Math.abs(this.getReferralCreditUsed * 100));
    },
    isShowReferAFriendReferralCredit() {
      return this.getReferralCreditUsed > 0;
    },
  },
};
</script>

<style lang="scss">
@import './index.scss';
</style>
